class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  checkGiftCardConditions() {
    // console.log("Checking gift card conditions...1111");
  const cartItems = document.querySelectorAll('.cart-item');

  cartItems.forEach((cartItem) => {
    const options = cartItem.querySelectorAll('.product-option');
    let hasCard = false, hasTo = false, hasFrom = false, hasMessage = false;

    options.forEach((option) => {
      const text = option.textContent.trim();
      if (text.startsWith('Card:')) hasCard = true;
      if (text.startsWith('To:')) hasTo = true;
      if (text.startsWith('From:')) hasFrom = true;
      if (text.startsWith('Message:')) hasMessage = true;
    });

    if (hasCard && hasTo && hasFrom && hasMessage) {
      const checkbox = cartItem.querySelector('.gift-card-checkbox');
      if (checkbox) checkbox.checked = true;
    }
  });
}

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('.cart-icon-bubble');

    if (cartLinks.length==0) return;
    // console.log("cartLINKS", cartLinks);
    cartLinks.forEach((cartLink)=>{
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    })

  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    this.checkGiftCardConditions();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // console.log("entering renderContents ========>",parsedState);
    
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    // console.log("this.getSectionsToRender() == ",this.getSectionsToRender());
    
    this.getSectionsToRender().forEach((section) => {
      // console.log("section--===== ",section," == ",section.selector);
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

        // console.log("sectionElement======",sectionElement);
        

      if (!sectionElement) return;
      // console.log("this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);=====>",this.getSectionInnerHTML(parsedState.sections[section.id], section.selector));

      // console.log("parsedState.sections[section.id]=====> ", section.id, " ===== ", parsedState.sections[section.id]);
      
      
      let changed_cart = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      // console.log("changed_cart======",changed_cart);
        
      sectionElement.innerHTML = changed_cart;
      
      if (parsedState.item_count === 0) {
        let dtaa1 = document.querySelector('.cart-drawer__warnings');
        let dtaa2 = document.querySelector('.item-drawer');
        // console.log("dtaa1 ====> ",dtaa1);
        
        if (dtaa1) {
          dtaa1.style.display = "flex";
          dtaa2.style.display = "none";
        }
      }

  

     const countElement = document.querySelector('#cart-icon-bubble .cart-count-bubble span:first-child');
    const real_count = countElement ? countElement.innerHTML.trim() : null;



      document.querySelector('#cart-icon-bubble-1 .cart-count-bubble').innerHTML = real_count;

      document.querySelector('#cart-icon-bubble-2 .cart-count-bubble').innerHTML = real_count;
    });

   

this.checkGiftCardConditions();




    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    // console.log("html -- - ---- ",html," ==== ",selector);
    
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      }
    ];
  }
  

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'cartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
